// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root {
    display: flex;
    flex-direction: column;
}

.container {
    display: flex;
    flex-direction: row;
    align-self: center;
    margin-bottom: 20px;
}

.container button  {
    margin-left: 5px;
}

#list-watches {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    gap: 20px 20px;
    width: 100%;
    align-self: center;
}

.watch {
    display: flex;
	width: 45%;
    padding: 40px;
    padding-bottom: 20px;
	position: relative;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.watch:after{
	content:'';
	position:absolute;
	height: 20px;
	border-radius: 100%;
	left: 50%;
	margin-left: -200px;
	bottom: 2px;
	z-index: -1;
}


.watch .display{
	text-align:center;
	padding: 40px 20px 20px;
	border-radius:6px;
	position:relative;
	height: 54px;
    margin-bottom: 10px;
}

/*-------------------------
	Light color theme
--------------------------*/

.light{
	background-color:#f3f3f3;
	color:#272e38;
}

.light:after{
	box-shadow:0 4px 10px rgba(0,0,0,0.15);
}

.light .digits div span{
	background-color:#272e38;
	border-color:#272e38;	
}

.light .digits div.dots:before,
.light .digits div.dots:after{
	background-color:#272e38;
}

.light .display{
	background-color:#dddddd;
	box-shadow:0 1px 1px rgba(0,0,0,0.08) inset, 0 1px 1px #fafafa;
}

/*-------------------------
	Dark color theme
--------------------------*/


.dark{
	background-color:#272e38;
	color:#cacaca;
}

.dark:after{
	box-shadow:0 4px 10px rgba(0,0,0,0.3);
}

.dark .digits div span{
	background-color:#cacaca;
	border-color:#cacaca;	
}

.dark .display{
	background-color:#0f1620;
	box-shadow:0 1px 1px rgba(0,0,0,0.08) inset, 0 1px 1px #2d3642;
}

.dark .digits div.dots:before,
.dark .digits div.dots:after{
	background-color:#cacaca;
}


/*-------------------------
	The Digits
--------------------------*/

.watch .digits {
    margin-right: 30px;
}

.watch .digits div{
	text-align:left;
	position:relative;
	width: 28px;
	height:50px;
	display:inline-block;
	margin:0 4px;
}

.watch .digits div span{
	opacity:0;
	position:absolute;

	-webkit-transition:0.25s;
	-moz-transition:0.25s;
	transition:0.25s;
}

.watch .digits div span:before,
.watch .digits div span:after{
	content:'';
	position:absolute;
	width:0;
	height:0;
	border:5px solid transparent;
}

.watch .digits .d1{			height:5px;width:16px;top:0;left:6px;}
.watch .digits .d1:before{	border-width:0 5px 5px 0;border-right-color:inherit;left:-5px;}
.watch .digits .d1:after{	border-width:0 0 5px 5px;border-left-color:inherit;right:-5px;}

.watch .digits .d2{			height:5px;width:16px;top:24px;left:6px;}
.watch .digits .d2:before{	border-width:3px 4px 2px;border-right-color:inherit;left:-8px;}
.watch .digits .d2:after{	border-width:3px 4px 2px;border-left-color:inherit;right:-8px;}

.watch .digits .d3{			height:5px;width:16px;top:48px;left:6px;}
.watch .digits .d3:before{	border-width:5px 5px 0 0;border-right-color:inherit;left:-5px;}
.watch .digits .d3:after{	border-width:5px 0 0 5px;border-left-color:inherit;right:-5px;}

.watch .digits .d4{			width:5px;height:14px;top:7px;left:0;}
.watch .digits .d4:before{	border-width:0 5px 5px 0;border-bottom-color:inherit;top:-5px;}
.watch .digits .d4:after{	border-width:0 0 5px 5px;border-left-color:inherit;bottom:-5px;}

.watch .digits .d5{			width:5px;height:14px;top:7px;right:0;}
.watch .digits .d5:before{	border-width:0 0 5px 5px;border-bottom-color:inherit;top:-5px;}
.watch .digits .d5:after{	border-width:5px 0 0 5px;border-top-color:inherit;bottom:-5px;}

.watch .digits .d6{			width:5px;height:14px;top:32px;left:0;}
.watch .digits .d6:before{	border-width:0 5px 5px 0;border-bottom-color:inherit;top:-5px;}
.watch .digits .d6:after{	border-width:0 0 5px 5px;border-left-color:inherit;bottom:-5px;}

.watch .digits .d7{			width:5px;height:14px;top:32px;right:0;}
.watch .digits .d7:before{	border-width:0 0 5px 5px;border-bottom-color:inherit;top:-5px;}
.watch .digits .d7:after{	border-width:5px 0 0 5px;border-top-color:inherit;bottom:-5px;}


/* 1 */

.watch .digits div.one .d5,
.watch .digits div.one .d7{
	opacity:1;
}

/* 2 */

.watch .digits div.two .d1,
.watch .digits div.two .d5,
.watch .digits div.two .d2,
.watch .digits div.two .d6,
.watch .digits div.two .d3{
	opacity:1;
}

/* 3 */

.watch .digits div.three .d1,
.watch .digits div.three .d5,
.watch .digits div.three .d2,
.watch .digits div.three .d7,
.watch .digits div.three .d3{
	opacity:1;
}

/* 4 */

.watch .digits div.four .d5,
.watch .digits div.four .d2,
.watch .digits div.four .d4,
.watch .digits div.four .d7{
	opacity:1;
}

/* 5 */

.watch .digits div.five .d1,
.watch .digits div.five .d2,
.watch .digits div.five .d4,
.watch .digits div.five .d3,
.watch .digits div.five .d7{
	opacity:1;
}

/* 6 */

.watch .digits div.six .d1,
.watch .digits div.six .d2,
.watch .digits div.six .d4,
.watch .digits div.six .d3,
.watch .digits div.six .d6,
.watch .digits div.six .d7{
	opacity:1;
}


/* 7 */

.watch .digits div.seven .d1,
.watch .digits div.seven .d5,
.watch .digits div.seven .d7{
	opacity:1;
}

/* 8 */

.watch .digits div.eight .d1,
.watch .digits div.eight .d2,
.watch .digits div.eight .d3,
.watch .digits div.eight .d4,
.watch .digits div.eight .d5,
.watch .digits div.eight .d6,
.watch .digits div.eight .d7{
	opacity:1;
}

/* 9 */

.watch .digits div.nine .d1,
.watch .digits div.nine .d2,
.watch .digits div.nine .d3,
.watch .digits div.nine .d4,
.watch .digits div.nine .d5,
.watch .digits div.nine .d7{
	opacity:1;
}

/* 0 */

.watch .digits div.zero .d1,
.watch .digits div.zero .d3,
.watch .digits div.zero .d4,
.watch .digits div.zero .d5,
.watch .digits div.zero .d6,
.watch .digits div.zero .d7{
	opacity:1;
}


/* The dots */

.watch .digits div.dots{
	width:5px;
}

.watch .digits div.dots:before,
.watch .digits div.dots:after{
	width:5px;
	height:5px;
	content:'';
	position:absolute;
	left:0;
	top:14px;
}

.watch .digits div.dots:after{
	top:34px;
}


.blink {
    -webkit-animation: animation 1s infinite;
	-moz-animation: animation 1s infinite;
    -o-animation: animation 1s infinite;
	-ms-animation: animation 1s infinite;
	animation: animation 1s infinite;
}
@keyframes animation {
    0% {
       	opacity: 1; 
    }
	100% {
		opacity: 0;
	}
}
@-webkit-keyframes animation {
    0% {
		opacity: 1; 
	}
	100% {
		opacity: 0;
	}
}
@-moz-keyframes animation {
    0% {
		opacity: 1; 
	}
	100% {
		opacity: 0;
	}
}
@-o-keyframes animation {
    0% {
		opacity: 1; 
	}
	100% {
		opacity: 0;
	}
}
@-ms-keyframes animation {
    0% {
		opacity: 1; 
	}
	100% {
		opacity: 0;
	}
}

/*-------------------------
		AM/PM
--------------------------*/


.watch .ampm{
	position:absolute;
	bottom:20px;
	right:20px;
	font-size:12px;
}


.button-container {
    margin-top: 10px;
    display: flex;
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
}

.button-container button {
	width: 24%;
    background-color: #0f1620;
    display: flex;
    text-align: center;
    border: none;
    color: white;
    padding: 15px 32px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 4px 2px;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;CAChB,UAAU;IACP,aAAa;IACb,oBAAoB;CACvB,kBAAkB;IACf,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;CACC,UAAU;CACV,iBAAiB;CACjB,YAAY;CACZ,mBAAmB;CACnB,SAAS;CACT,mBAAmB;CACnB,WAAW;CACX,WAAW;AACZ;;;AAGA;CACC,iBAAiB;CACjB,uBAAuB;CACvB,iBAAiB;CACjB,iBAAiB;CACjB,YAAY;IACT,mBAAmB;AACvB;;AAEA;;2BAE2B;;AAE3B;CACC,wBAAwB;CACxB,aAAa;AACd;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,wBAAwB;CACxB,oBAAoB;AACrB;;AAEA;;CAEC,wBAAwB;AACzB;;AAEA;CACC,wBAAwB;CACxB,8DAA8D;AAC/D;;AAEA;;2BAE2B;;;AAG3B;CACC,wBAAwB;CACxB,aAAa;AACd;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,wBAAwB;CACxB,oBAAoB;AACrB;;AAEA;CACC,wBAAwB;CACxB,8DAA8D;AAC/D;;AAEA;;CAEC,wBAAwB;AACzB;;;AAGA;;2BAE2B;;AAE3B;IACI,kBAAkB;AACtB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,WAAW;CACX,WAAW;CACX,oBAAoB;CACpB,YAAY;AACb;;AAEA;CACC,SAAS;CACT,iBAAiB;;CAEjB,wBAAwB;CACxB,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;;CAEC,UAAU;CACV,iBAAiB;CACjB,OAAO;CACP,QAAQ;CACR,4BAA4B;AAC7B;;AAEA,sBAAsB,UAAU,CAAC,UAAU,CAAC,KAAK,CAAC,QAAQ,CAAC;AAC3D,2BAA2B,wBAAwB,CAAC,0BAA0B,CAAC,SAAS,CAAC;AACzF,0BAA0B,wBAAwB,CAAC,yBAAyB,CAAC,UAAU,CAAC;;AAExF,sBAAsB,UAAU,CAAC,UAAU,CAAC,QAAQ,CAAC,QAAQ,CAAC;AAC9D,2BAA2B,wBAAwB,CAAC,0BAA0B,CAAC,SAAS,CAAC;AACzF,0BAA0B,wBAAwB,CAAC,yBAAyB,CAAC,UAAU,CAAC;;AAExF,sBAAsB,UAAU,CAAC,UAAU,CAAC,QAAQ,CAAC,QAAQ,CAAC;AAC9D,2BAA2B,wBAAwB,CAAC,0BAA0B,CAAC,SAAS,CAAC;AACzF,0BAA0B,wBAAwB,CAAC,yBAAyB,CAAC,UAAU,CAAC;;AAExF,sBAAsB,SAAS,CAAC,WAAW,CAAC,OAAO,CAAC,MAAM,CAAC;AAC3D,2BAA2B,wBAAwB,CAAC,2BAA2B,CAAC,QAAQ,CAAC;AACzF,0BAA0B,wBAAwB,CAAC,yBAAyB,CAAC,WAAW,CAAC;;AAEzF,sBAAsB,SAAS,CAAC,WAAW,CAAC,OAAO,CAAC,OAAO,CAAC;AAC5D,2BAA2B,wBAAwB,CAAC,2BAA2B,CAAC,QAAQ,CAAC;AACzF,0BAA0B,wBAAwB,CAAC,wBAAwB,CAAC,WAAW,CAAC;;AAExF,sBAAsB,SAAS,CAAC,WAAW,CAAC,QAAQ,CAAC,MAAM,CAAC;AAC5D,2BAA2B,wBAAwB,CAAC,2BAA2B,CAAC,QAAQ,CAAC;AACzF,0BAA0B,wBAAwB,CAAC,yBAAyB,CAAC,WAAW,CAAC;;AAEzF,sBAAsB,SAAS,CAAC,WAAW,CAAC,QAAQ,CAAC,OAAO,CAAC;AAC7D,2BAA2B,wBAAwB,CAAC,2BAA2B,CAAC,QAAQ,CAAC;AACzF,0BAA0B,wBAAwB,CAAC,wBAAwB,CAAC,WAAW,CAAC;;;AAGxF,MAAM;;AAEN;;CAEC,SAAS;AACV;;AAEA,MAAM;;AAEN;;;;;CAKC,SAAS;AACV;;AAEA,MAAM;;AAEN;;;;;CAKC,SAAS;AACV;;AAEA,MAAM;;AAEN;;;;CAIC,SAAS;AACV;;AAEA,MAAM;;AAEN;;;;;CAKC,SAAS;AACV;;AAEA,MAAM;;AAEN;;;;;;CAMC,SAAS;AACV;;;AAGA,MAAM;;AAEN;;;CAGC,SAAS;AACV;;AAEA,MAAM;;AAEN;;;;;;;CAOC,SAAS;AACV;;AAEA,MAAM;;AAEN;;;;;;CAMC,SAAS;AACV;;AAEA,MAAM;;AAEN;;;;;;CAMC,SAAS;AACV;;;AAGA,aAAa;;AAEb;CACC,SAAS;AACV;;AAEA;;CAEC,SAAS;CACT,UAAU;CACV,UAAU;CACV,iBAAiB;CACjB,MAAM;CACN,QAAQ;AACT;;AAEA;CACC,QAAQ;AACT;;;AAGA;IACI,wCAAwC;CAC3C,qCAAqC;IAClC,mCAAmC;CACtC,oCAAoC;CACpC,gCAAgC;AACjC;AACA;IACI;QACI,UAAU;IACd;CACH;EACC,UAAU;CACX;AACD;AACA;IACI;EACF,UAAU;CACX;CACA;EACC,UAAU;CACX;AACD;AACA;IACI;EACF,UAAU;CACX;CACA;EACC,UAAU;CACX;AACD;AACA;IACI;EACF,UAAU;CACX;CACA;EACC,UAAU;CACX;AACD;AACA;IACI;EACF,UAAU;CACX;CACA;EACC,UAAU;CACX;AACD;;AAEA;;2BAE2B;;;AAG3B;CACC,iBAAiB;CACjB,WAAW;CACX,UAAU;CACV,cAAc;AACf;;;AAGA;IACI,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;CACC,UAAU;IACP,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,eAAe;AACnB","sourcesContent":["#root {\n    display: flex;\n    flex-direction: column;\n}\n\n.container {\n    display: flex;\n    flex-direction: row;\n    align-self: center;\n    margin-bottom: 20px;\n}\n\n.container button  {\n    margin-left: 5px;\n}\n\n#list-watches {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: row;\n    gap: 20px 20px;\n    width: 100%;\n    align-self: center;\n}\n\n.watch {\n    display: flex;\n\twidth: 45%;\n    padding: 40px;\n    padding-bottom: 20px;\n\tposition: relative;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.watch:after{\n\tcontent:'';\n\tposition:absolute;\n\theight: 20px;\n\tborder-radius: 100%;\n\tleft: 50%;\n\tmargin-left: -200px;\n\tbottom: 2px;\n\tz-index: -1;\n}\n\n\n.watch .display{\n\ttext-align:center;\n\tpadding: 40px 20px 20px;\n\tborder-radius:6px;\n\tposition:relative;\n\theight: 54px;\n    margin-bottom: 10px;\n}\n\n/*-------------------------\n\tLight color theme\n--------------------------*/\n\n.light{\n\tbackground-color:#f3f3f3;\n\tcolor:#272e38;\n}\n\n.light:after{\n\tbox-shadow:0 4px 10px rgba(0,0,0,0.15);\n}\n\n.light .digits div span{\n\tbackground-color:#272e38;\n\tborder-color:#272e38;\t\n}\n\n.light .digits div.dots:before,\n.light .digits div.dots:after{\n\tbackground-color:#272e38;\n}\n\n.light .display{\n\tbackground-color:#dddddd;\n\tbox-shadow:0 1px 1px rgba(0,0,0,0.08) inset, 0 1px 1px #fafafa;\n}\n\n/*-------------------------\n\tDark color theme\n--------------------------*/\n\n\n.dark{\n\tbackground-color:#272e38;\n\tcolor:#cacaca;\n}\n\n.dark:after{\n\tbox-shadow:0 4px 10px rgba(0,0,0,0.3);\n}\n\n.dark .digits div span{\n\tbackground-color:#cacaca;\n\tborder-color:#cacaca;\t\n}\n\n.dark .display{\n\tbackground-color:#0f1620;\n\tbox-shadow:0 1px 1px rgba(0,0,0,0.08) inset, 0 1px 1px #2d3642;\n}\n\n.dark .digits div.dots:before,\n.dark .digits div.dots:after{\n\tbackground-color:#cacaca;\n}\n\n\n/*-------------------------\n\tThe Digits\n--------------------------*/\n\n.watch .digits {\n    margin-right: 30px;\n}\n\n.watch .digits div{\n\ttext-align:left;\n\tposition:relative;\n\twidth: 28px;\n\theight:50px;\n\tdisplay:inline-block;\n\tmargin:0 4px;\n}\n\n.watch .digits div span{\n\topacity:0;\n\tposition:absolute;\n\n\t-webkit-transition:0.25s;\n\t-moz-transition:0.25s;\n\ttransition:0.25s;\n}\n\n.watch .digits div span:before,\n.watch .digits div span:after{\n\tcontent:'';\n\tposition:absolute;\n\twidth:0;\n\theight:0;\n\tborder:5px solid transparent;\n}\n\n.watch .digits .d1{\t\t\theight:5px;width:16px;top:0;left:6px;}\n.watch .digits .d1:before{\tborder-width:0 5px 5px 0;border-right-color:inherit;left:-5px;}\n.watch .digits .d1:after{\tborder-width:0 0 5px 5px;border-left-color:inherit;right:-5px;}\n\n.watch .digits .d2{\t\t\theight:5px;width:16px;top:24px;left:6px;}\n.watch .digits .d2:before{\tborder-width:3px 4px 2px;border-right-color:inherit;left:-8px;}\n.watch .digits .d2:after{\tborder-width:3px 4px 2px;border-left-color:inherit;right:-8px;}\n\n.watch .digits .d3{\t\t\theight:5px;width:16px;top:48px;left:6px;}\n.watch .digits .d3:before{\tborder-width:5px 5px 0 0;border-right-color:inherit;left:-5px;}\n.watch .digits .d3:after{\tborder-width:5px 0 0 5px;border-left-color:inherit;right:-5px;}\n\n.watch .digits .d4{\t\t\twidth:5px;height:14px;top:7px;left:0;}\n.watch .digits .d4:before{\tborder-width:0 5px 5px 0;border-bottom-color:inherit;top:-5px;}\n.watch .digits .d4:after{\tborder-width:0 0 5px 5px;border-left-color:inherit;bottom:-5px;}\n\n.watch .digits .d5{\t\t\twidth:5px;height:14px;top:7px;right:0;}\n.watch .digits .d5:before{\tborder-width:0 0 5px 5px;border-bottom-color:inherit;top:-5px;}\n.watch .digits .d5:after{\tborder-width:5px 0 0 5px;border-top-color:inherit;bottom:-5px;}\n\n.watch .digits .d6{\t\t\twidth:5px;height:14px;top:32px;left:0;}\n.watch .digits .d6:before{\tborder-width:0 5px 5px 0;border-bottom-color:inherit;top:-5px;}\n.watch .digits .d6:after{\tborder-width:0 0 5px 5px;border-left-color:inherit;bottom:-5px;}\n\n.watch .digits .d7{\t\t\twidth:5px;height:14px;top:32px;right:0;}\n.watch .digits .d7:before{\tborder-width:0 0 5px 5px;border-bottom-color:inherit;top:-5px;}\n.watch .digits .d7:after{\tborder-width:5px 0 0 5px;border-top-color:inherit;bottom:-5px;}\n\n\n/* 1 */\n\n.watch .digits div.one .d5,\n.watch .digits div.one .d7{\n\topacity:1;\n}\n\n/* 2 */\n\n.watch .digits div.two .d1,\n.watch .digits div.two .d5,\n.watch .digits div.two .d2,\n.watch .digits div.two .d6,\n.watch .digits div.two .d3{\n\topacity:1;\n}\n\n/* 3 */\n\n.watch .digits div.three .d1,\n.watch .digits div.three .d5,\n.watch .digits div.three .d2,\n.watch .digits div.three .d7,\n.watch .digits div.three .d3{\n\topacity:1;\n}\n\n/* 4 */\n\n.watch .digits div.four .d5,\n.watch .digits div.four .d2,\n.watch .digits div.four .d4,\n.watch .digits div.four .d7{\n\topacity:1;\n}\n\n/* 5 */\n\n.watch .digits div.five .d1,\n.watch .digits div.five .d2,\n.watch .digits div.five .d4,\n.watch .digits div.five .d3,\n.watch .digits div.five .d7{\n\topacity:1;\n}\n\n/* 6 */\n\n.watch .digits div.six .d1,\n.watch .digits div.six .d2,\n.watch .digits div.six .d4,\n.watch .digits div.six .d3,\n.watch .digits div.six .d6,\n.watch .digits div.six .d7{\n\topacity:1;\n}\n\n\n/* 7 */\n\n.watch .digits div.seven .d1,\n.watch .digits div.seven .d5,\n.watch .digits div.seven .d7{\n\topacity:1;\n}\n\n/* 8 */\n\n.watch .digits div.eight .d1,\n.watch .digits div.eight .d2,\n.watch .digits div.eight .d3,\n.watch .digits div.eight .d4,\n.watch .digits div.eight .d5,\n.watch .digits div.eight .d6,\n.watch .digits div.eight .d7{\n\topacity:1;\n}\n\n/* 9 */\n\n.watch .digits div.nine .d1,\n.watch .digits div.nine .d2,\n.watch .digits div.nine .d3,\n.watch .digits div.nine .d4,\n.watch .digits div.nine .d5,\n.watch .digits div.nine .d7{\n\topacity:1;\n}\n\n/* 0 */\n\n.watch .digits div.zero .d1,\n.watch .digits div.zero .d3,\n.watch .digits div.zero .d4,\n.watch .digits div.zero .d5,\n.watch .digits div.zero .d6,\n.watch .digits div.zero .d7{\n\topacity:1;\n}\n\n\n/* The dots */\n\n.watch .digits div.dots{\n\twidth:5px;\n}\n\n.watch .digits div.dots:before,\n.watch .digits div.dots:after{\n\twidth:5px;\n\theight:5px;\n\tcontent:'';\n\tposition:absolute;\n\tleft:0;\n\ttop:14px;\n}\n\n.watch .digits div.dots:after{\n\ttop:34px;\n}\n\n\n.blink {\n    -webkit-animation: animation 1s infinite;\n\t-moz-animation: animation 1s infinite;\n    -o-animation: animation 1s infinite;\n\t-ms-animation: animation 1s infinite;\n\tanimation: animation 1s infinite;\n}\n@keyframes animation {\n    0% {\n       \topacity: 1; \n    }\n\t100% {\n\t\topacity: 0;\n\t}\n}\n@-webkit-keyframes animation {\n    0% {\n\t\topacity: 1; \n\t}\n\t100% {\n\t\topacity: 0;\n\t}\n}\n@-moz-keyframes animation {\n    0% {\n\t\topacity: 1; \n\t}\n\t100% {\n\t\topacity: 0;\n\t}\n}\n@-o-keyframes animation {\n    0% {\n\t\topacity: 1; \n\t}\n\t100% {\n\t\topacity: 0;\n\t}\n}\n@-ms-keyframes animation {\n    0% {\n\t\topacity: 1; \n\t}\n\t100% {\n\t\topacity: 0;\n\t}\n}\n\n/*-------------------------\n\t\tAM/PM\n--------------------------*/\n\n\n.watch .ampm{\n\tposition:absolute;\n\tbottom:20px;\n\tright:20px;\n\tfont-size:12px;\n}\n\n\n.button-container {\n    margin-top: 10px;\n    display: flex;\n    width: 100%;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n}\n\n.button-container button {\n\twidth: 24%;\n    background-color: #0f1620;\n    display: flex;\n    text-align: center;\n    border: none;\n    color: white;\n    padding: 15px 32px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 16px;\n    margin: 4px 2px;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
